import { signIn as signInReq } from "api/authApi"
import { UNAUTHORIZED_EVENT, clearUserToken } from "api/axiosClient"
import { AxiosError } from "axios"
import Auth from "component/Auth"
import { TokenModel } from "model/TokenModel"
import { FC, ReactNode, createContext, useEffect, useState } from "react"
import Cookies from "universal-cookie"

interface IAuthContext {
  // Текст ошибки входа или undefined, если вошли
  signIn: (email: string, password: string) => Promise<string | undefined>
  signOut: () => void
}

const AuthContext = createContext<IAuthContext>({} as IAuthContext)

interface AuthContextProviderProps {
  children: ReactNode
}

const AuthContextProvider: FC<AuthContextProviderProps> = ({ children }) => {
  const cookies = new Cookies()
  const [token, setToken] = useState<TokenModel | undefined>(cookies.get("token"))

  const signIn = async (email: string, password: string) => {
    let reqToken: TokenModel
    try {
      reqToken = await signInReq(email, password)
    } catch (error) {
      // Причину показывает форма входа (уведомления до входа не смонтированы).
      // Бэк пишет "Учётная запись заблокирована"; на неверный пароль —
      // по-английски, поэтому свой текст
      const response = (error as AxiosError).response
      const detail = (response?.data as { detail?: string } | undefined)?.detail
      return response?.status === 403 && detail ? detail : "Неверный логин или пароль"
    }
    // Старые cookie на путях страниц перекрыли бы новый токен
    clearUserToken()
    // path "/" — один cookie на весь сайт, с какой бы страницы ни входили
    cookies.set("token", reqToken, { path: "/" })
    setToken(reqToken)
  }

  const signOut = () => {
    clearUserToken()
    setToken(undefined)
  }

  // Токен недействителен (401) — показываем форму входа на той же странице:
  // после входа URL не меняется, и страница (например, проверка по ссылке
  // из бота) загрузится сама
  useEffect(() => {
    const handleUnauthorized = () => setToken(undefined)
    window.addEventListener(UNAUTHORIZED_EVENT, handleUnauthorized)
    return () => window.removeEventListener(UNAUTHORIZED_EVENT, handleUnauthorized)
  }, [])

  if (!token) {
    return <Auth signIn={signIn} />
  }

  return (
    <AuthContext.Provider
      value={{
        signIn,
        signOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export { AuthContext, AuthContextProvider }

export type { IAuthContext }
